var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: _vm.title, size: "lg", "hide-footer": "", centered: "" },
    },
    [
      _c(
        "div",
        { staticClass: "p-1" },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Aula" } },
            [
              _c("b-form-select", {
                attrs: { options: _vm.lessonOptions },
                on: { change: _vm.loadImpact },
                model: {
                  value: _vm.lessonId,
                  callback: function ($$v) {
                    _vm.lessonId = $$v
                  },
                  expression: "lessonId",
                },
              }),
            ],
            1
          ),
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("cancellation.club_cancel_reason") } },
            [
              _c("b-form-select", {
                staticClass: "required",
                attrs: { options: _vm.reasonOptions },
                model: {
                  value: _vm.reason,
                  callback: function ($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason",
                },
              }),
            ],
            1
          ),
          _vm.impact
            ? _c("div", { staticClass: "border rounded p-1 mb-2" }, [
                _c("div", { staticClass: "font-medium mb-1" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_impact"))),
                ]),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_students"))),
                  ]),
                  _c("small", [_vm._v(_vm._s(_vm.impact.affected_students))]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_refund"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.formatValue(_vm.impact.full_refund_total))
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_transfer"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.formatValue(_vm.impact.settled_transfer_reversal)
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_fee"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(_vm.formatValue(_vm.impact.hubee_fee_returned))
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass:
                "flex justify-between items-center border rounded p-1 mb-2",
            },
            [
              _c("div", [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$t("cancellation.club_cancel_mass_reschedule"))
                  ),
                ]),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_mass_hint"))),
                ]),
              ]),
              _c("b-form-checkbox", {
                attrs: { switch: "" },
                model: {
                  value: _vm.offerReschedule,
                  callback: function ($$v) {
                    _vm.offerReschedule = $$v
                  },
                  expression: "offerReschedule",
                },
              }),
            ],
            1
          ),
          _c(
            "b-alert",
            { staticClass: "p-1 mb-2", attrs: { show: "", variant: "danger" } },
            [
              _c(
                "div",
                { staticClass: "flex items-start" },
                [
                  _c("feather-icon", {
                    staticClass: "mr-1 flex-shrink-0",
                    attrs: { icon: "AlertTriangleIcon" },
                  }),
                  _c("small", [
                    _vm._v(_vm._s(_vm.$t("cancellation.club_cancel_warning"))),
                  ]),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex justify-end gap-4" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.close },
                },
                [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "danger",
                    disabled: !_vm.impact || !_vm.impact.affected_students,
                  },
                  on: { click: _vm.execute },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("cancellation.club_cancel_confirm", {
                          count: _vm.impact ? _vm.impact.affected_students : 0,
                        })
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }